import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { forgotPasswordAction } from '@mobile-dev/platform/common/redux/actions/CarrierLogin';
import NewBrandLogo from '../../assets/images/FreightSmith_LOGO_Final.png'
import { useHistory } from "react-router-dom";
import { clearError } from '@mobile-dev/platform/common/redux/actions/CommonAction';
import LoaderButton from "../Common/LoaderButton";
import ErrornDialog from "../Common/ErrorDialog/ErrorDialog";
import { showAlert, stickyInfoAlert, toastOptions } from "../../Utils/Utility";
import { toast } from "react-toastify";
import { emailPattern, signupValidation } from "../../Utils/ValidationUtils";
import LoaderSubmitButton from "../Common/LoaderSubmitButton";
import { isEmpty } from 'lodash';
import { useForm } from 'react-hook-form'

function ForgotPassword() {

    const [email, setEmail] = useState('');
    const dispatch = useDispatch();
    const history = useHistory();
    const error = useSelector(state => state.carrierLogin.error);
    const loading = useSelector(state => state.carrierLogin.loading);
    const { handleSubmit, register, formState: { errors } } = useForm();
    const toastId = useRef(null);

    useEffect(() => {
        dispatch(clearError());
    }, []);


    const onSubmit = (data) => {
        
        if(data.email){
        dispatch(forgotPasswordAction(data.email));
        stickyInfoAlert(toast.TYPE.INFO, `An email has been sent to ${data.email} containing the Verification code , Your verification code may take up to 1-2 minutes to receive. Thank you for waiting`);
        history.push({ pathname: '/resetPassword', state: { username: data.email } });
        return null;
        }
        else{
            showAlert(toast.TYPE.ERROR,'Please provide the email');
        }
    }

    if (!isEmpty(errors)) {
        if (!isEmpty(errors)) {
            Object.keys(errors).map(e => {
                signupValidation.filter(s => s.name === e).forEach(v => {
                    if (!toast.isActive(toastId.current)) {
                        toastOptions.autoClose = true;
                        toastOptions.type = 'warning';
                        toastId.current = toast(v.message, toastOptions);
                    }
                });
            });
        }
    }

    return (
        <form className="form-signin" onSubmit={handleSubmit(onSubmit)}>
            <div className="card">

                <div className="card-header uc-blue"></div>

                <div className="card-header text-center bg-header">
                    <span className="text-dark-50 fa-lg">
                        <img className="img-fluid smith_logo" src={NewBrandLogo} alt="FreightSmith logo" />
                    </span>
                </div>
                <div className="card-body p-4">
                    <div className="text-center m-auto">
                        <p className="text-muted mb-4">Enter your eMail to Reset Password</p>

                    </div>
                    <div className="mb-3">
                        <label htmlFor="eMail" className="required"> Email address</label>
                        <input type="text" name="email" className="form-control"
                            placeholder="Enter Email" defaultValue={email}
                            {...register("email", { required: true, pattern: emailPattern })}
                        />

                    </div>
                    <LoaderSubmitButton
                        className='btn btn-chartreuse btn-height btn-block'
                        name='Submit'
                        loading={loading}
                    />
                </div>
            </div>
            {error && <ErrornDialog
                error={error?.message}
                open
            />}
        </form>
    )
}

export default ForgotPassword;